import TrackingLink from '../TrackingLink'

export const Buffalo = () => {
    return (
        <>
            <ul>
                <li>Princess Races este o secțiune dedicată turneelor organizate de Princess Casino sau de partenerii furnizori de jocuri.
                </li>
                <li>Promoţia este deschisă participării tuturor persoanelor fizice cu vârsta de peste 18 ani, cu capacitate deplină de exerciţiu și care au un cont activ și verificat pe website-ul PrincessCasino.ro.
                </li>
                <li>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din promoție.
                </li>
                <li>Promoția are loc începând de vineri, 20 mai, ora 15:00 până luni, 23 februarie ora 23:59.
                </li>
            </ul>
            <p><strong>Participare</strong></p>
            <ul>
                <li>Jocul eligibil este: Big Buffalo Badlands
                </li>
                <li>Punctajul unui jucător este suma tuturor punctelor obținute la jocurile eligibile, din pariuri realizate cu bani cash în perioada desfășurării competiției.
                </li>
                <li>Pariul minim pentru această cursă este de 1 RON.</li>
            </ul>
            <p><strong>Premii</strong></p>
            <span>Poți obține un premiu în trei feluri:</span>
            <p><strong>Telefoane iPhone 13</strong></p>
            <ul>
                <li>Pentru a se califica în extragerea pentru un iPhone, un jucător trebuie să ruleze zilnic pe perioada campaniei 500 RON din balanța cash la jocul participant în promoție.
                </li>
                <li>Pe parcursul promoției, sunt acordate 3 telefoane iPhone 13. Desemnarea câștigătorilor se va face prin extragere, pe website-ul random.org, rezultatele urmând a fi afișate pe pagina Princess Races
                </li>
            </ul>
            <p><strong>Premii instant</strong></p>
            <ul>
                <li>În total sunt acordate câte 600 de premii de valori diferite. Premiile sunt atribuite aleatoriu, la fiecare 5 minute, între orele 10:00 și 23:55 (excepție făcând prima zi a competiției în care calificarea se face începând de vineri, ora 15:00 și până vineri, ora 23:59).
                </li>
                <li>Pentru a fi eligibil un jucător trebuie să adune minim 10 puncte (să ruleze minim 10 RON CASH) zilnic la jocul participant în promoție.
                </li>
            </ul>
            <p><strong>Premii clasament</strong></p>
            <ul>
                <li>Adună cât mai multe puncte și califică-te în top 50 pentru unul dintre premiile puse la bătaie.</li>
                <li>Premiile vor fi acordate în balanța jucătorului, în următoarele 48 de ore de la încheierea competiției.</li>
                <li>Jucătorii vor fi anunțați pe email sau SMS după realizarea creditării premiului</li>
            </ul>
            <div className="terms-table">
                <div className="terms-table-header">
                    <div className="terms-table-row">
                        <div className="terms-table-data"><strong>Locul</strong></div>
                        <div className="terms-table-data"><strong>Premii</strong></div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">1</div>
                        <div className="terms-table-data">2,000 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">2</div>
                        <div className="terms-table-data">1,200 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">3</div>
                        <div className="terms-table-data">800 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">4</div>
                        <div className="terms-table-data">450 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">5</div>
                        <div className="terms-table-data">300 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">6-10</div>
                        <div className="terms-table-data">200 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">11-15</div>
                        <div className="terms-table-data">150 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">16-20</div>
                        <div className="terms-table-data">100 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">21-30</div>
                        <div className="terms-table-data">50 RON CASH</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">31-50</div>
                        <div className="terms-table-data">25 RON CASH</div>
                    </div>
                </div>
            </div>
            <p><strong>Termenii și condițiile competiției:</strong></p>
            <ul>
                <li>Promoția are loc începând de vineri, 20 mai, ora 15:00 până luni, 23 mai,ora 23:59.
                </li>
                <li>Jocul eligibil este: Big Buffalo Badlands
                </li>
                <li>Promoția se bazează pe un clasament, ce are drept criteriu de poziționare a jucătorilor suma punctelor adunate din pariurile plasate în jocul participant.
                </li>
                <li>Cele mai bune scoruri sunt puse în partea de sus a clasamentului.</li>
                <li>Vor fi premiate primele 50 de locuri disponibile conform tabelului prezentat în descrierea promoției.
                </li>
                <li>În cazul în care este egalitate de puncte între doi jucători, suma totală rulată va fi folosită ca
                    un criteriu de departajare. În situația în care este egalitate perfectă de puncte și de sumă totală
                    rulată pe perioada promoției, premiul va fi împărțit între jucători.
                </li>
                <li>Pentru a îndeplini condițiile de retragere a câștigurilor rezultate din folosirea bonusului sau a rundelor, jucătorii vor trebui să mizeze de 40x valoarea bonusului primit.</li>
                <li>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și
                    excluse din promoție în scopuri de punctaj.
                </li>
                <li>Premiile care pot fi câștigate pot fi găsite în secțiunea Ce câștig? din descrierea promoției.</li>
                <li>Premiile vor fi acordate în balanță jucătorilor în următoarele 48 de ore de la încheierea
                    competiției.
                </li>
                <li>Premiile vor fi acordate doar jucătorilor cu un cont activ. Utilizatorii care au solicitat
                    închiderea contului de joc (indiferent de motiv) până la finalizarea competiției, nu vor fi
                    eligibili pentru acordarea premiului.
                </li>
                <li>Oferta respectă <TrackingLink href="https://www.princesscasino.ro/terms-conditions">Termenii și Condițiile
                    Princess Casino</TrackingLink>.
                </li>
                <li>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii,
                    fără explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine
                    Regulilor Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va prevala.
                </li>
                <li>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi
                    multiple.
                </li>
                <li>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte
                    fără notificare prealabilă.
                </li>
                <li>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                    asistență la adresa de e-mail <a
                        href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.
                </li>
            </ul>
        </>
    )
}